import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./styles/themes.css";
import "./styles/responsive.css";

import { ThemeProvider } from "./context/ThemeContext";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import Clients from "./pages/Clients";
import ClientDetail from "./pages/ClientDetail";
import Missions from "./pages/Mission";
import MissionDetail from "./pages/MissionDetail";
import Signalements from "./pages/Signalements";
import SignalementDetail from "./pages/SignalementDetail";
import Paiements from "./pages/Paiements";
import PaiementDetail from "./pages/PaiementDetail";
import Services from "./pages/Services";
import Vehicules from "./pages/Vehicules";
import Abonnement from "./pages/Abonnements";
import CreateAbonnement from "./pages/CreateAbonnement";
import EditAbonnement from "./pages/EditAbonnement";
import Publicite from "./pages/Publicite";
import Prestataires from "./pages/Prestataires";
import PrestataireDetail from "./pages/PrestataireDetail";
import PubliciteDetail from "./pages/PubliciteDetail";
import PubliciteEdit from "./pages/PubliciteEdit";
import MainLayout from "./components/MainLayout";
import SettingsPage from "./pages/SettingsPage";
import PasswordChangeConfirmation from "./pages/PasswordChangeConfirmation";
import ForgotPassword from "./pages/ForgotPassword";
import VerificationCode from "./pages/VerificationCode";
import ResetPassword from "./pages/ResetPassword";
import PasswordResetSuccess from "./pages/PasswordResetSuccess";
import InternalUsersPage from "./pages/InternalUsersPage";
import DocumentValidation from "./pages/DocumentValidation";
import NotificationsPage from "./pages/NotificationsPage";
import Support from "./pages/Support";
import SupportDetail from "./pages/SupportDetail";
import MonCompte from "./pages/MonCompte";

import { AuthProvider } from "./contexts/AuthContext";
import { SearchProvider } from "./contexts/SearchContext";
import { NotificationProvider } from "./contexts/NotificationContext";
import ProtectedRoute from "./components/ProtectedRoute";
import { ToastProvider } from "./components/ToastContainer";

function App() {
  return (
    <ThemeProvider>
    <AuthProvider>
      <SearchProvider>
        <ToastProvider>
          <NotificationProvider>
            <Router>
        <Routes>
          {/* Routes publiques */}
          <Route path="/" element={<LoginPage />} />
          <Route path="/mot-de-passe-oublie" element={<ForgotPassword />} />
          <Route path="/verify-code" element={<VerificationCode />} />
          <Route path="/nouveau-mot-de-passe" element={<ResetPassword />} />
          <Route path="/password/success" element={<PasswordChangeConfirmation />} />
          <Route path="/password/reset-success" element={<PasswordResetSuccess />} />

          {/* Routes protégées */}
          <Route
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/clients/:id" element={<ClientDetail />} />
            <Route path="/prestataires" element={<Prestataires />} />
            <Route path="/prestataires/:id" element={<PrestataireDetail />} />
            <Route path="/missions" element={<Missions />} />
            <Route path="/missions/:id" element={<MissionDetail />} />
            <Route path="/abonnements" element={<Abonnement />} />
            <Route path="/abonnements/create" element={<CreateAbonnement />} />
            <Route path="/abonnements/edit/:id" element={<EditAbonnement />} />
            <Route path="/signalements" element={<Signalements />} />
            <Route path="/signalements/:id" element={<SignalementDetail />} />
            <Route path="/publicite" element={<Publicite />} />
            <Route path="/publicite/:id" element={<PubliciteDetail />} />
            <Route path="/publicite/:id/edit" element={<PubliciteEdit />} />
            <Route path="/vehicules" element={<Vehicules />} />
            <Route path="/services" element={<Services />} />
            <Route path="/paiements" element={<Paiements />} />
            <Route path="/paiements/:id" element={<PaiementDetail />} />
            <Route path="/parametres" element={<SettingsPage />} />
            <Route path="/parametres/success" element={<PasswordChangeConfirmation />} />
            <Route path="/utilisateurs-internes" element={<InternalUsersPage />} />
            <Route path="/validation-documents" element={<DocumentValidation />} />
            <Route path="/mon-compte" element={<MonCompte />} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/support" element={<Support />} />
            <Route path="/support/:id" element={<SupportDetail />} />
          </Route>
        </Routes>
            </Router>
          </NotificationProvider>
        </ToastProvider>
      </SearchProvider>
    </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
